<template>
  <div class="search">
    <div class="search-head">
      <div class="left">
        物流运单明细
      </div>
      <div class="close" @click="close">
        <img src="@/assets/images/home/back.png" />
        返回
      </div>
    </div>
    <div class="title">运单信息</div>
    <div class="order">
      <div class="head">
        <div class="items">
          <div class="ite">
            <div class="ite-left">订单编码:</div>
            <div class="ite-right">
              {{ this.showDetail.customerNumber || "--" }}
            </div>
          </div>
          <div class="ite">
            <div class="ite-left">订单总金额:</div>
            <div class="ite-right">
              {{ this.showDetail.transaction || "--" }}
            </div>
          </div>
          <div class="ite">
            <div class="ite-left">订单总重量:</div>
            <div class="ite-right">
              {{ this.showDetail.totalWeight || "--" }}
            </div>
          </div>
          <div class="ite">
            <div class="ite-left">平台名称:</div>
            <div class="ite-right">{{ this.showDetail.platform || "--" }}</div>
          </div>
        </div>
        <div class="items">
          <div class="ite">
            <div class="ite-left">店铺名称:</div>
            <div class="ite-right">{{ this.showDetail.storeName || '--' }}</div>
          </div>
          <div class="ite">
            <div class="ite-left">物流运单号:</div>
            <div class="ite-right">
              {{ this.showDetail.trackNumber || "--" }}
            </div>
          </div>
          <div class="ite">
            <div class="ite-left">包裹总件数:</div>
            <div class="ite-right">{{ this.showDetail.number || "--" }}</div>
          </div>
          <div class="ite">
            <div class="ite-left">运抵国:</div>
            <div class="ite-right">
              {{ this.showDetail.countryName || "--" }}
            </div>
          </div>
        </div>
        <div class="items">
          <div class="ite">
            <div class="ite-left">物流企业名称:</div>
            <div class="ite-right">{{ this.showDetail.orgName || "--" }}</div>
          </div>
          <div class="ite">
            <div class="ite-left">运费USD:</div>
            <div class="ite-right">
              {{ this.showDetail.shippingPrice || "--" }}
            </div>
          </div>
          <div class="ite">
            <!-- <div class="ite-left">保费USD:</div>
            <div class="ite-right">{{ "--" }}</div> -->
          </div>
          <div class="ite"></div>
        </div>
      </div>
      <div></div>
    </div>
    <div class="title">收发货人信息</div>
    <div class="order">
      <div class="head">
        <div class="items">
          <div class="ite">
            <div class="ite-left">收件人名称:</div>
            <div class="ite-right">
              {{ this.showDetail.recipientName || "--" }}
            </div>
          </div>
          <div class="ite">
            <div class="ite-left">收件人联系电话:</div>
            <div class="ite-right">
              {{ this.showDetail.recipientTel || "--" }}
            </div>
          </div>
          <div class="ite">
            <div class="ite-left">收件人地址:</div>
            <div class="ite-right">
              {{ this.showDetail.recipientAddres || "--" }}
            </div>
          </div>
        </div>
        <div class="items">
          <div class="ite">
            <div class="ite-left">发件人名称:</div>
            <div class="ite-right">{{ this.showDetail.sendName || "--" }}</div>
          </div>
          <div class="ite">
            <div class="ite-left">发件人联系电话:</div>
            <div class="ite-right">{{ this.showDetail.sendTel || "--" }}</div>
          </div>
          <div class="ite">
            <div class="ite-left">发件人地址:</div>
            <div class="ite-right">
              {{ this.showDetail.sendAddres || "--" }}
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <!-- <div class="ux-filter-records filter-records">
            <div class='content-list' style="height:auto">
              <el-table
                empty-text="暂无数据"
                class="table ux-dark-el-table"
                :data="tableData"
                max-height="565"
                element-loading-spinner="el-icon-loading">
                <el-table-column width='80' type='index' label='序号' align='center'>
                  </el-table-column>
                  <el-table-column v-for="(props, i) in tableHeader" :label='props.label' align="left" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                    <div v-if="props.prop === 'itemLength'">
                        <div>{{ getItemLength(scope.row) }}</div>
                    </div>
                    <div v-else>
                        <div class="text">{{ scope.row[props.prop] || '--' }}</div>
                    </div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                @current-change="currentChange"
              />
              <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
            </div>
          </div> -->
  </div>
</template>
<script>
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
const { mapState } = require('vuex')
export default {
  components: { pagination },
  data () {
    return {
      tableData: [],
      tableHeader: [
        {
          label: '商品名称',
          prop: 'itemName'
        },
        {
          label: '商品sku',
          prop: 'itemAttr'
        },
        {
          label: '商品重量',
          prop: 'itemWeight'
        },
        {
          label: '商品单价',
          prop: 'note'
        },
        {
          label: '商品数量',
          prop: 'qtyOrdered'
        },
        {
          label: '计量单位',
          prop: 'note'
        },
        {
          label: '商品长宽高',
          prop: 'itemLength'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      currentChange (e) {
        this.page.current = e
        this.getList()
      },
      sizeChange (e) {
        this.page.current = 1
        this.page.size = e
        this.getList()
      },
      getItemLength (row) {
        return (
          `${row.itemLength}` +
          '-' +
          `${row.itemWidth}` +
          '-' +
          `${row.itemHeight}`
        )
      }
    }
  },
  created () {
    // this.getList()
  },
  computed: {
    ...mapState({
      searchDate: state => {
        return state.home.searchDate
      },
      showDetail: state => {
        return state.home.showDetail
      }
    })
  },
  methods: {
    getList () {
      let data = {
        // 'companyName': this.row.info.companyName,
        companyNo: this.showDetail.info.companyNo,
        pageIndex: this.page.current,
        pageSize: this.page.size,
        searchDate: this.searchDate
        // guid: this.row.guid
      }
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listLogisticsDetail}`,
        data: data
      }).then(res => {
        if (res.data) {
          this.tableData = res.data || []
          this.page.total = res.total || 0
        }
      })
    },
    // 关闭弹框
    close () {
      this.$store.dispatch('getisShowDetail', 1)
      this.$store.dispatch('getShowDetail', {})
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  padding: 40px 40px;
  width: calc(100% - 80px);
}
.search-head {
  font-size: 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.close {
  display: flex;
  box-sizing: content-box;
  padding: 5px;
  height: 24px;
  cursor: pointer;
  width: 87px;
  height: 30px;
  font-size: 20px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}
.title {
  margin-bottom: 10px;
}
.order {
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid rgba(37, 92, 152, 1);
  margin-bottom: 10px;
  .head {
    padding: 28px 0px 0px;
    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      .ite {
        display: flex;
        width: 25%;
        .ite-left {
          width: 50%;
          text-align: right;
        }
        .ite-right {
          width: 50%;
          text-align: left;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.ux-filter-records {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px 35px 0px 0px;
  box-sizing: border-box;
  .filter {
    display: flex;
    flex-wrap: wrap;
    // div {
    //   margin-right: 18px;
    //   margin-bottom: 10px;
    // }
    .search {
      color: #ffffff;
      background: #1c8be2;
    }
  }
  .content-list {
    margin-top: 10px;
    flex: none;
    // min-height: 550px;
    .table {
      height: 100%;
      .el-table__header-wrapper {
        tr {
          th {
            height: 50px;
          }
        }
      }
      .el-table__body-wrapper {
        tr {
          td {
            height: 50px;
          }
        }
      }
      .el-loading-mask {
        /* background: rgba(0, 0, 0, 0.8); */
        .el-loading-spinner {
          font-size: 24px;
        }
      }
      .text {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    .ux-dark-el-table {
      display: flex;
      flex-direction: column;
      border: 1px solid #2d6bab;
      background-color: transparent;
      table {
        thead {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color: #fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
      td.el-table__cell {
        border-bottom: 1px solid #2d6bab;
      }
      &::before {
        display: none;
      }
      // tbody row hover
      &.el-table--enable-row-hover
        .el-table__body
        tr:hover
        > td.el-table__cell {
        background: rgba(24, 127, 215, 0.2);
      }
      // 多级表头
      &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
        content: unset;
      }
      .el-table__body-wrapper {
        flex: 1 1;
        table {
          height: 100%;
        }
      }
      .el-table__footer-wrapper tbody td.el-table__cell {
        font-size: 16px;
        background-color: transparent;
      }
    }
  }
  .pages {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 28px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/components/wlDetail.vue